import { UserIdleService } from "angular-user-idle";
import { EnvironmentService } from "../environment/environment.service";
import { NgZone, Injectable } from '@angular/core';
import { merge, fromEvent } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ItauUserIdleService extends UserIdleService {

    constructor(private environmentService: EnvironmentService, _ngZone: NgZone) {
        super(
            {
                idle: environmentService.envModel.itauUserIdleSettings.idle,
                timeout: environmentService.envModel.itauUserIdleSettings.timeout,
                ping: environmentService.envModel.itauUserIdleSettings.ping
            },
            _ngZone
           
        );

        super.setCustomActivityEvents(
            merge(
                fromEvent(window, 'mousemove'),
                fromEvent(window, 'mouseclick'),
                fromEvent(window, 'dblclick'),
                fromEvent(window, 'wheel'),
                fromEvent(window, 'resize'),
                fromEvent(document, 'keydown'),
                fromEvent(document, 'touchstart'),
                fromEvent(document, 'touchend')
            )
        );
    }

    getRedirectUri() : String {
      return this.environmentService.envModel.redirectUri;
    }
}